<template>
    <div>
        <h3>レーティング</h3>
        <div>
            <p>
                小説と記事にはレーティングが設定されています。
                無し、R15、R18、XXXの４種類ですが、これらはセルフレーティングであるため、
                大まかな目安となります。
            </p>
            <h4>未登録ユーザーの場合</h4>
            <p>
                未登録ユーザーは、R18作品までの小説がポータルに表示されます。
                作者の本棚では、制限なくすべての作品が表示されます。
            </p>
            <h4>登録ユーザの場合</h4>
            <p>
                登録ユーザーは、登録直後はレーティング「R18」となっています。
                アカウント設定によって、表示できるレーティングをコントロールできます。
                R15に設定すれば、「無し」と「R15」のみが表示され、「R18」「XXX」は表示されません。
                これはポータルだけでなく、作者の本棚でも同じように表示コントロールされます。
            </p>
            <img src="/img/help/read/05.png" alt="レーティング設定" class="img-thumbnail mb-3">
        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>

<script>
export default {
    created() {
        this.useHead({
            title: "レーティング | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>